<template>
        <div class="agree">
            <div class="content" v-html="AgreementData"></div>
        </div>
</template>
<script>
import {fetchVerifyAuthForB} from '@/libsV2/havc.js'
export default {
    computed:{
        AgreementData() {
            return this.$store.state.userTalkAppointV3.AgreementData || this.$store.state.userTalkAppointV2.AgreementData
        },
    },
    methods:{

    },
}
</script>
<style lang='scss' scoped>
    .agree{
        position: absolute;
        top: 0;left: 0;right: 0;
        bottom: 0;
        overflow-x:hidden;
        overflow-y:scroll;
        background: #fff;
            .content{
                padding: 20px;
            }
        }
</style>
